<div class="errorMessage" *ngIf="formError">
  <div>{{ formErrorMessage }}</div>
  <div *ngFor="let item of formFieldsErrors">
    {{ item }}
  </div>
</div>
